import router from "@/router";
import {getToken} from "@/utils/auth";
import store from "@/store";

const whiteList = ['/login','/register']

router.beforeEach(async (to, from, next) => {
    const token = getToken();
    if (token) {
        if (to.path === '/login') {
            next({path: '/'})
        } else {
            const hasGetUserInfo = store.getters.username
            if (hasGetUserInfo) {
                next()
            } else {
                try {
                    await store.dispatch('user/getInfo')
                    next()
                } catch (error) {
                    console.log(error)
                    // getInfo 失败也必须 resolve 导航，否则 next() 永不调用会导致路由挂起白屏。
                    // 201（登录失效）已由 request.js 统一处理，这里兜底：先清 token 再回登录页，
                    // 否则「带 token 访问 /login」会被上面的分支重定向回首页，形成死循环。
                    store.dispatch('user/resetToken').finally(() => {
                        next(`/login?redirect=${to.path}`)
                    })
                }
            }

        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next(`/login?redirect=${to.path}`)
        }

    }
})